import React from "react";
import { IconButton } from "@mui/material";
import { copyText } from "../libs/utils";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export default function CopyButton({text, size = "small"}: {text: string, size?: "small" | "medium"}) {
    return (
        <IconButton
            onClick={() => copyText(text)}
            size={size}
            sx={{ml: 1}}
        >
            <ContentCopyIcon fontSize="small" />
        </IconButton>
    );
}